import { LocalStorageKey } from '@/shared/config';

import { safeLocalStorage } from './safeLocalStorage';

// A presign sign-in stands in for the second factor: the server marks the
// session MFA-compliant, so the client must not prompt for enrolment either.
export const markPresignMFAExempt = () => {
  safeLocalStorage.setItem(LocalStorageKey.presignMFAExempt, 'true');
};

export const clearPresignMFAExempt = () => {
  safeLocalStorage.removeItem(LocalStorageKey.presignMFAExempt);
};

export const isPresignMFAExempt = () =>
  safeLocalStorage.getItem(LocalStorageKey.presignMFAExempt) === 'true';
